import { GTM_EVENT_ACTIONS, GTM_EVENT_PAGES, GTM_EVENT_PLACES } from '../../constants';
import { BREADCRUMB_TYPES } from '../../utils/bread-crumbs';

const EVENTS = {
  MATCH_CLICK: {
    event: 'match_click',
    action: GTM_EVENT_ACTIONS.CLICK,
  },
  LEAGUE_CLICK: {
    event: 'league_click',
    action: GTM_EVENT_ACTIONS.CLICK,
  },
};

export const getTrackingData = breadCrumbType => {
  switch (breadCrumbType) {
    case BREADCRUMB_TYPES.SPORTSLIST:
    case BREADCRUMB_TYPES.OUTRIGHTSLIST:
      return null;
    case BREADCRUMB_TYPES.LEAGUESLIST:
      return {
        ...EVENTS.LEAGUE_CLICK,
        place: GTM_EVENT_PLACES.BREADCRUMBS,
        page: GTM_EVENT_PAGES.MATCH,
      };
    default:
      return {
        ...EVENTS.MATCH_CLICK,
        place: GTM_EVENT_PLACES.BREADCRUMBS,
        page: GTM_EVENT_PAGES.MATCH,
      };
  }
};
